// default
export const RISK_ASSESSMENT_RISK_DATABASE = 'riskAssessmentRiskDatabase';
export const RISK_ASSESSMENT_RISK_DATABASE_SLICE_NAME = `${RISK_ASSESSMENT_RISK_DATABASE}Slice`;

// works
const GET_RISK_DATABASE_WORKS = `${RISK_ASSESSMENT_RISK_DATABASE}/GET_RISK_DATABASE_WORKS`;
const ADD_RISK_DATABASE_WORKS = `${RISK_ASSESSMENT_RISK_DATABASE}/ADD_RISK_DATABASE_WORKS`;
const DELETE_RISK_DATABASE_WORKS = `${RISK_ASSESSMENT_RISK_DATABASE}/DELETE_RISK_DATABASE_WORKS`;
const UPDATE_RISK_DATABASE_WORKS = `${RISK_ASSESSMENT_RISK_DATABASE}/UPDATE_RISK_DATABASE_WORKS`;
const EXCEL_ADD_RISK_DATABASE_WORKS = `${RISK_ASSESSMENT_RISK_DATABASE}/EXCEL_ADD_RISK_DATABASE_WORKS`;
const ADD_RISK_DATABASE_WORKS_BATCH = `${RISK_ASSESSMENT_RISK_DATABASE}/ADD_RISK_DATABASE_WORKS_BATCH`;

// hazard
const GET_RISK_DATABASE_HAZARD = `${RISK_ASSESSMENT_RISK_DATABASE}/GET_RISK_DATABASE_HAZARD`;
const ADD_RISK_DATABASE_HAZARD = `${RISK_ASSESSMENT_RISK_DATABASE}/ADD_RISK_DATABASE_HAZARD`;
const DELETE_RISK_DATABASE_HAZARD = `${RISK_ASSESSMENT_RISK_DATABASE}/DELETE_RISK_DATABASE_HAZARD`;
const UPDATE_RISK_DATABASE_HAZARD = `${RISK_ASSESSMENT_RISK_DATABASE}/UPDATE_RISK_DATABASE_HAZARD`;
const ADD_RISK_DATABASE_HAZARD_BATCH = `${RISK_ASSESSMENT_RISK_DATABASE}/ADD_RISK_DATABASE_HAZARD_BATCH`;

// activity
const GET_RISK_DATABASE_ACTIVITY = `${RISK_ASSESSMENT_RISK_DATABASE}/GET_RISK_DATABASE_ACTIVITY`;
const ADD_RISK_DATABASE_ACTIVITY = `${RISK_ASSESSMENT_RISK_DATABASE}/ADD_RISK_DATABASE_ACTIVITY`;
const DELETE_RISK_DATABASE_ACTIVITY = `${RISK_ASSESSMENT_RISK_DATABASE}/DELETE_RISK_DATABASE_ACTIVITY`;
const UPDATE_RISK_DATABASE_ACTIVITY = `${RISK_ASSESSMENT_RISK_DATABASE}/UPDATE_RISK_DATABASE_ACTIVITY`;
const ADD_RISK_DATABASE_ACTIVITY_BATCH = `${RISK_ASSESSMENT_RISK_DATABASE}/ADD_RISK_DATABASE_ACTIVITY_BATCH`;

// actions
export const riskDatabaseActions = {
  GET_RISK_DATABASE_WORKS,
  ADD_RISK_DATABASE_WORKS,
  DELETE_RISK_DATABASE_WORKS,
  UPDATE_RISK_DATABASE_WORKS,
  EXCEL_ADD_RISK_DATABASE_WORKS,
  GET_RISK_DATABASE_HAZARD,
  ADD_RISK_DATABASE_HAZARD,
  DELETE_RISK_DATABASE_HAZARD,
  UPDATE_RISK_DATABASE_HAZARD,
  GET_RISK_DATABASE_ACTIVITY,
  ADD_RISK_DATABASE_ACTIVITY,
  DELETE_RISK_DATABASE_ACTIVITY,
  UPDATE_RISK_DATABASE_ACTIVITY,
  ADD_RISK_DATABASE_ACTIVITY_BATCH,
  ADD_RISK_DATABASE_HAZARD_BATCH,
  ADD_RISK_DATABASE_WORKS_BATCH
};
